// extracted by css-extract-rspack-plugin
export default {"gallery-images":"GalleryModal-module__gallery-images--L7DyX","galleryImages":"GalleryModal-module__gallery-images--L7DyX","footer":"GalleryModal-module__footer--lHHv2"};